// extracted by mini-css-extract-plugin
module.exports = {"playerWrap":"styles_playerWrap__3oRCQ","iframeItem":"styles_iframeItem__1KyCt"};